import React, {useState} from 'react';
import NowNameTableFilter from '../../../Components/Filter/NowNameTableFilter';
import s from '../ProductReport.module.css';
import styleTableGrid from '../../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import style from '../../PaperworkList/PaperworkList.module.css';
import NowNameTableRowEl from '../components/NowNameTableRowEl';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import AddFilterButton from '../../../Components/Buttons/AddFilterButton';
import SearchWindow from '../../../Components/SearchWindow/SearchWindow';
import {useTranslation} from 'react-i18next';
import {useGetGoodsMovementQuery} from '../../../redux/DepotSlice/depotReportApi';
import {RequestGoodsMovementType} from '../../../types/StoreReportTypes';
import {monthNow, todayDate} from '../../../assets/utils/dateUtils';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';

const GoodsMovementTable: React.FC = () => {
	const {t} = useTranslation();
	const [nowNameTableFilter, setNoNameTableFilter] = useState(false);
	const [productName, setProductName] = useState<string>('');
	const [filters, setFilters] = useState<RequestGoodsMovementType>({
		from_date: monthNow(),
		to_date: todayDate(),
		product_name: 'Баланс',
	});
	const {data, isFetching} = useGetGoodsMovementQuery(filters);
	const handleSubmit = (values: RequestGoodsMovementType) => {
		setFilters({...values, product_name: productName});
	};
	const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		setProductName(event.target.value);
	};
	const handleClickSearch = () => {
		setFilters({...filters, product_name: productName});
	};
	return (
		<div className={s.tableContainer}>
			<div className={s.title}>{t('Таблиця руху товару')}</div>
			<div className={s.filterButton}>
				<AddFilterButton
					color={'blue'}
					setFilterMenu={setNoNameTableFilter}
					filterMenu={nowNameTableFilter}
				/>
				<SearchWindow
					value={productName}
					handleChange={handleChangeSearch}
					handleClick={handleClickSearch}
				/>
			</div>
			<NowNameTableFilter
				active={nowNameTableFilter}
				handleSubmit={handleSubmit}
			/>
			{isFetching ? (
				<PreLoaderComponent type={'circle'} size={'big'} />
			) : (
				data?.movements && (
					<>
						<div className={s.nowNameTable}>
							<div className={s.tableWrapper}>
								<div className={styleTableGrid.tableGrid}>
									<GridTableHead
										columns={['', t('Назва'), t('Дата'), t('Кількість'), t('Вид дії')]}
										gridTemplateColumns="1fr 3fr 2fr 1fr 3fr"
										customClassName={styleTableGrid.tableRow}
									/>
									{data.movements.map((movement) => (
										<NowNameTableRowEl
											product={movement}
											key={movement.product_id}
										/>
									))}

									<div className={s.buttonWrapper}>
										<LightGreenButton text={t('Дивитись більше')} type={'button'} />
									</div>
								</div>
							</div>
						</div>
					</>
				)
			)}
		</div>
	);
};

export default GoodsMovementTable;
